import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { productParamsById } from 'config/products';
import { useTranslation } from '@wix/wix-i18n-config';
import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import styles from '../SelectProductsStep.scss';

export const SelectProductsStepPreview: FC = () => {
  const { t } = useTranslation();

  const selectedProducts = useAppStore((state) => state.selectedProducts);

  return (
    <div className={styles.selectProductsStepPreview}>
      <div className={styles.selectProductsStepPreviewContent}>
        {selectedProducts.length === 0 && <div className={styles.selectProductsStepPreviewContentEmpty} />}
        {selectedProducts.map((productId) => {
          const product = productParamsById[productId];
          return (
            <div key={productId} className={styles.selectProductsStepPreviewContentItem}>
              <ProductCard
                buyButtonText={t('select-products-step.preview.product-card.button-text')}
                imageUrl={product.imageUrl}
                name={product.name}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
